
import { Season } from "@/models/GameType";
import StringHelper from "@/utils/StringHelper";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: {},
})
class AddSeason extends Vue {
  @Prop({ default: "" }) readonly gameType!: string;
  displayName = "";
  errorMessage = "";
  notes = "";

  get getSlugifyName(): string {
    return StringHelper.Slugify(this.displayName);
  }

  get getSeasonData(): Season[] {
    return this.$store.state.gameStore.gameType;
  }

  created(): void {
    this.$v.$touch();
  }
  cancel(): void {
    this.$bvModal.hide("team-modal-add-season");
  }
  saveSeason(): void {
    var data = {
      seasonName: this.displayName,
      slug: this.getSlugifyName,
      notes: this.notes,
    };
    if (this.getSeasonData.find((x) => x.slug === this.getSlugifyName)) {
      this.errorMessage = "An city with the same slug already exists.";
      this.$bvModal.show("modal-sm");
    } else {
      if (this.displayName.length > 0 && /[a-z]/i.test(this.displayName)) {
        if (this.gameType === "quest") {
          this.$store
            .dispatch("gameStore/insertNewSeasonQuest", data)
            .then((results) => {
              if (results === "success") {
                this.displayName = "";
                this.$bvModal.hide("team-modal-add-season");
              } else {
                //display erorr

                console.log(results);
              }
            });
        } else {
          this.$store
            .dispatch("gameStore/insertNewSeason", data)
            .then((results) => {
              if (results === "success") {
                this.displayName = "";
                this.$bvModal.hide("team-modal-add-season");
              } else {
                //display erorr

                console.log(results);
              }
            });
        }
      } else {
        this.$bvModal.show("modal-sm");
        this.errorMessage =
          "Please make sure the display name is not empty and contains at least one letter";
      }
    }
  }

  @Validations()
  validations = {
    displayName: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(160),
    },
    notes: {
      required,
      minLength: minLength(3),
    },
  };
}

export default AddSeason;
